import { tns } from 'tiny-slider/src/tiny-slider';

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('[data-carousel]');

  if (carousels) {
    carousels.forEach(carousel => {
      const slides = carousel.querySelector('[data-carousel-slides]');
      const settingsDefault = {
        container: slides,
        controlsText: ['<span>Previous Slide</span>', '<span>Next Slide</span>'],
        nav: false,
        speed: 800,
        center: false,
        loop: true,
        startIndex: 0,
        items: 1,
        responsive: {
          1020: {
            // startIndex: 1
          }
        }
      };

      // initialize tiny-slider
      carousel = tns(settingsDefault);
    });
  }
});
